import { cn } from '@/lib/utils';

export interface StepVerticalLog {
    description: string;
    detail?: string;
    timestamp: string;
}

export interface StepVerticalItem {
    id: string;
    title: string;
    logs: StepVerticalLog[];
}

interface StepVerticalProps {
    items: StepVerticalItem[];
    activeIndex?: number;
    title?: string;
    footnote?: string;
    className?: string;
}

const StepVertical = ({
    items,
    activeIndex = 0,
    title = 'Status Pengiriman',
    footnote = 'Waktu ditampilkan dalam zona waktu lokal.',
    className,
}: StepVerticalProps) => {
    return (
        <div className={cn('shadowCard p-3 flex flex-col gap-3', className)}>
            {title && <h3 className="title2medium text-black">{title}</h3>}

            <ol className="flex flex-col">
                {items.map((item, index) => {
                    const isActive = index === activeIndex;
                    const isLast = index === items.length - 1;

                    return (
                        <li key={item.id} className="relative flex gap-3">
                            <div className="flex flex-col items-center">
                                <span
                                    aria-hidden
                                    className={cn(
                                        'mt-[3px] flex size-5 shrink-0 items-center justify-center rounded-full',
                                        isActive ? 'bg-[#00C483]/10' : 'bg-gray-100',
                                    )}
                                >
                                    <span
                                        className={cn(
                                            'size-2 rounded-full',
                                            isActive ? 'bg-[#00C483]' : 'bg-gray-300',
                                        )}
                                    />
                                </span>
                                {!isLast && <span aria-hidden className="w-px flex-1 bg-gray-200" />}
                            </div>

                            {/* Content */}
                            <div className={cn('flex flex-1 flex-col gap-3', !isLast && 'pb-4')}>
                                <p
                                    className={cn(
                                        'title3medium',
                                        isActive ? 'text-black' : 'text-text-grey',
                                    )}
                                    aria-current={isActive ? 'step' : undefined}
                                >
                                    {item.title}
                                </p>

                                {item.logs.length > 0 && (
                                    <ul className="flex flex-col gap-3">
                                        {item.logs.map((log, logIndex) => (
                                            <li key={`${item.id}-${logIndex}`} className="flex flex-col gap-1">
                                                <p className="reg12 text-text-grey">{log.description}</p>
                                                {log.detail && (
                                                    <p className="reg12 text-text-grey">{log.detail}</p>
                                                )}
                                                <p className="reg12 text-text-grey">{log.timestamp}</p>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </li>
                    );
                })}
            </ol>

            {footnote && <p className="reg12 text-text-grey">{footnote}</p>}
        </div>
    );
};

export default StepVertical;
